/**
 * All application settings should be defined here following the ECS configuration structure.
 * Please insert new settings in alphabetical order, to preserve readability and reduce chance of merge conflict.
 */

export const defaultApplicationSettings = {
    Loki: {
        resourceUrl: 'https://loki.delve.office.com/',
    },
};
